import { Transition, Variants } from "motion/react";

import {
  blueMui,
  deepPurpleMui,
  greenMui,
  greyMui,
  indigoMui,
  lightBlueMui,
  orangeMui,
  purpleMui,
  tealMui,
} from "@ryde/theme";

import {
  ISystemParamCategoryPalette,
  TSystemParamCategoryTone,
} from "./system-params.category.models";

export const SYSTEM_PARAM_CATEGORY_KEYS = {
  general: "general",
  rides: "rides",
  production: "production",
  map: "map",
  shifts: "shifts",
  waitingList: "waitinglist",
  bookings: "bookings",
  interfaces: "interfaces",
  passengersApp: "passengersapp",
  login: "login",
  translations: "translations",
  driverApp: "driverapp",
} as const;

export type TSystemParamCategoryKey =
  (typeof SYSTEM_PARAM_CATEGORY_KEYS)[keyof typeof SYSTEM_PARAM_CATEGORY_KEYS];

export const SYSTEM_PARAM_CATEGORY_PALETTE: ISystemParamCategoryPalette = {
  idle: {
    backgroundColor: greyMui._100,
    color: greyMui._800,
    boxShadow: `inset 0 0 0 1px ${greyMui._300}`,
  },
};

export const SYSTEM_PARAM_CATEGORY_HEADER_TONES: Record<
  TSystemParamCategoryKey,
  TSystemParamCategoryTone
> = {
  [SYSTEM_PARAM_CATEGORY_KEYS.general]: {
    bg: greenMui._50,
    text: greenMui._700,
    border: greenMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.rides]: {
    bg: blueMui._50,
    text: blueMui._700,
    border: blueMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.production]: {
    bg: orangeMui._50,
    text: orangeMui._700,
    border: orangeMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.map]: {
    bg: purpleMui._50,
    text: purpleMui._700,
    border: purpleMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.shifts]: {
    bg: tealMui._50,
    text: tealMui._700,
    border: tealMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.waitingList]: {
    bg: indigoMui._50,
    text: indigoMui._700,
    border: indigoMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.bookings]: {
    bg: deepPurpleMui._50,
    text: deepPurpleMui._700,
    border: deepPurpleMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.interfaces]: {
    bg: lightBlueMui._50,
    text: lightBlueMui._700,
    border: lightBlueMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.passengersApp]: {
    bg: deepPurpleMui._50,
    text: deepPurpleMui._700,
    border: deepPurpleMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.login]: {
    bg: tealMui._50,
    text: tealMui._700,
    border: tealMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.translations]: {
    bg: indigoMui._50,
    text: indigoMui._700,
    border: indigoMui._200,
  },
  [SYSTEM_PARAM_CATEGORY_KEYS.driverApp]: {
    bg: lightBlueMui._50,
    text: lightBlueMui._700,
    border: lightBlueMui._200,
  },
};

export const SYSTEM_PARAM_CATEGORY_HEADER_TONE_KEYS = Object.keys(
  SYSTEM_PARAM_CATEGORY_HEADER_TONES,
) as TSystemParamCategoryKey[];

export const SYSTEM_PARAMS_TAB_PANEL_TRANSITION: Transition = {
  duration: 0.4,
  ease: [0.22, 1, 0.36, 1],
};

export const SYSTEM_PARAMS_TAB_PANEL_VARIANTS: Variants = {
  initial: {
    opacity: 0.55,
    y: 3,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
};

export const SYSTEM_PARAMS_TAB_PANEL_REDUCED_MOTION_VARIANTS: Variants = {
  initial: {
    opacity: 0.85,
  },
  animate: {
    opacity: 1,
  },
};
